import React from "react";

const Storage = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M33.222 12.947V18c0 4.185-6.766 7.579-15.11 7.579C9.765 25.579 3 22.185 3 18v-5.053c0 4.186 6.766 7.58 15.111 7.58s15.111-3.394 15.111-7.58zM3 21.368c0 4.186 6.766 7.58 15.111 7.58s15.111-3.394 15.111-7.58v5.053c0 4.185-6.766 7.579-15.11 7.579C9.765 34 3 30.606 3 26.421v-5.053zm15.111-4.21C9.766 17.158 3 13.764 3 9.578c0-4.184 6.766-7.578 15.111-7.578s15.111 3.394 15.111 7.579-6.766 7.579-15.11 7.579z"
            fill={fill}
        />
    </svg>
);

export default Storage;
